import React, { useEffect, useState } from "react";
import "./Gateway.css";

const Gateway = () => {
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");
    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <>
      <div>
        <div class="wrapper" id="cover">
          <img
            src={require("../../Assets/images/cover-gateway.jpeg")}
            class="prx"
            style={{ height: "205px", width: "100%" }}
          />
          <h1>{rtl ? `بوابة` : fr ? `La Porte d'entrée ` : `Gateway`}</h1>
        </div>
      </div>

      <section class="section innerpage bg" id="Africa">
        <div class="gateway-content">
          <div class="row m-0 saaf">
            <sidebar style={{ width: "22%" }}>
              {/* <h3 class="title c-4 ff-regular">Gateway</h3>
                            <span class="border">&nbsp;</span>
                            <ul>
                                <li class="">
                                    <a href="#Africa">To Africa</a>
                                </li>
                                <li class="">
                                    <a href="#GatewaySaudi">To Saudi Arabia</a>
                                </li>
                            </ul> */}
              <img
                src={require("../../Assets/images/image.png")}
                alt="Gold Africa"
              />
              <img
                src={require("../../Assets/images/saudi.png")}
                alt="saudi Flag"
                style={{ transform: "translateY(500px)" }}
              />
              <img
                src={require("../../Assets/images/asia.png")}
                alt="Asia"
                style={{
                  transform: "translateY(564px) scale(1.15)",
                }}
              />
            </sidebar>

            <div style={{ width: "58%" }} class="gatewayToAfricaAndAsia">
              <h3 class="title c-4 ff-regular">
                {rtl
                  ? `بوابة أفريقيا وآسيا`
                  : fr
                  ? `LA PORTE D'ENTRÉE VERS L'AFRIQUE ET L'ASIE`
                  : `GATEWAY TO AFRICA AND ASIA`}
              </h3>
              <span class="border"></span>
              <br />
              <div class="content">
                <h3
                  class="title c-4 ff-regular"
                  style={{
                    color: "#d8a419",
                    marginBottom: "20px",
                  }}
                  id="GatewaySaudi"
                >
                  {rtl
                    ? `غينيا بوابة الى أفريقيا`
                    : fr
                    ? `GUINÉE EST LA PORTE D'ENTRÉE VERS L'AFRIQUE`
                    : `Guinea Gateway to Africa`}
                </h3>
                <img
                  src={require("../../Assets/images/image.png")}
                  style={{ display: "none" }}
                  id="goldAfricaImage"
                  alt="Gold Africa"
                />
                <p>
                  <span
                    class="title c-4"
                    style={{
                      float: "none",
                      fontSize: "25px",
                    }}
                  >
                    {rtl
                      ? `كما يقول المثل،`
                      : fr
                      ? `Comme le dit le proverbe, `
                      : ` As the saying goes,`}
                  </span>{" "}
                  {rtl
                    ? ` تبدأ رحلة الألف ميل بخطوة واحدة. وبالنسبة لبنك الاستثمار الإسلامي، تحدد كل خطوة جوهر ما نقدره. يبدأ الأمر بالناس واحتياجاتهم الأساسية والمعرفة والإلهام اللازمين للازدهار والنمو والنجاح طوال حياتهم. سنركز على شبابنا لمساعدتهم على الازدهار بطرق غير متاحة لهم اليوم. سيتم الكشف عن رؤيتنا بالكامل حيث تتقاطع بنوكنا عبر القارة الأفريقية وتلمس ملايين الأرواح`
                    : fr
                    ? `un voyage de mille kilomètres commence par un seul pas. Et pour La Mecque et la Médine Banque,
                    chaque pas définit l'essence de ce que nous valorisons. Cela commence par les personnes, leurs besoins fondamentaux, ainsi
                    que les connaissances et l'inspiration nécessaires pour s'épanouir, grandir et réussir tout au long de leur vie. Nous nous
                    concentrerons sur nos jeunes pour les aider à s'épanouir d'une manière qui ne leur est pas accessible aujourd'hui. Notre vision
                    se révélera pleinement lorsque nos banques sillonneront le continent africain et toucheront des millions de vies.`
                    : `a journey of a thousand miles begins with a
                                    single step. And for The Islamic investment
                                    Bank, each step defines the essence of what
                                    we value. It starts with people, their basic
                                    needs, and the knowledge and inspiration
                                    required to thrive, grow and be successful
                                    throughout their lives. We will focus on our
                                    young people to help them flourish in ways
                                    unavailable to them today. Our vision will
                                    be revealed fully as our banks crisscross
                                    the African continent and touch millions of
                                    lives.`}
                </p>
                <p>
                  <span
                    class="title c-4"
                    style={{
                      float: "none",
                      fontSize: "25px",
                    }}
                  >
                    {rtl
                      ? `وقد وضع بنك الاستثمار الإسلامي`
                      : fr
                      ? `La Mecque et la Médine Banque`
                      : `The Islamic investment Bank`}{" "}
                  </span>
                  {rtl
                    ? ` خطة مبتكرة للتنمية الاقتصادية لأفريقيا بأسرها، ولا سيما للبلدان ومواطنيها الذين يرغبون في المشاركة. ستستفيد "الدول الشريكة" من التسجيل في برنامج "بوابة إلى أفريقيا" من خلال تجربة كمية غير مسبوقة من الاستثمار الخارجي ومستوى جديد من التعاون بين الدول. برنامجنا شامل ومصمم خصيصا للمساعدة في خلق فرصة نهضة للبلدان الشريكة لنا`
                    : fr
                    ? `a créé un plan de développement économique innovant pour l'ensemble de l'Afrique et, en
                    particulier, pour les pays et leurs citoyens qui souhaitent y participer. Nos "pays partenaires" bénéficieront de l'inscription à
                    notre programme " Porte d'entrée à l'Afrique " en faisant l'expérience d'un montant sans précédent d'investissements
                    extérieurs et d'un nouveau niveau de coopération entre les nations. Notre programme est complet et spécifiquement conçu
                    pour aider à créer une opportunité de renaissance pour nos pays partenaires.`
                    : `has created an innovative economic
                                    development plan for the whole of Africa
                                    and, in particular, for those countries and
                                    their citizens that wish to participate. Our
                                    “partner countries” will benefit from
                                    enrolling in our “Gateway to Africa” program
                                    by experiencing an unprecedented amount of
                                    outside investment and a new level of
                                    cooperation between nations. Our program is
                                    comprehensive and specifically designed to
                                    help create a renaissance opportunity for
                                    our partner countries.`}
                </p>
                <p>
                  <span
                    class="title c-4"
                    style={{
                      float: "none",
                      fontSize: "25px",
                    }}
                  >
                    {rtl
                      ? `تقع رواسب الذهب 
`
                      : fr
                      ? `Les gisements d'or`
                      : `Gold deposits`}{" "}
                  </span>
                  {rtl
                    ? `   في جميع أنحاء منطقة الذهب العربية الوسطى
(CAGR)
 ، وهي منطقة جيولوجية تمتد من ساحل البحر الأحمر إلى وسط البلاد. كان تطوير معدل النمو السنوي المركب صعبا بسبب موقعه البعيد ومحدودية توافر المياه.
`
                    : fr
                    ? `sont situés dans toute la région aurifère de l'Arabie centrale (CAGR), une zone géologique qui s'étend de la
                    côte de la mer Rouge au centre du pays. Le développement de la CAGR a été difficile en raison de son éloignement et de la
                    disponibilité limitée de l'eau.`
                    : `are located throughout the Central Arabian
                                    Gold Region (CAGR), a geological area
                                    extending from the Red Sea coast to the
                                    middle of the country. Development of the
                                    CAGR has been challenging due to its remote
                                    location and limited water availability.`}
                </p>
                <p>
                  <span
                    class="title c-4"
                    style={{
                      float: "none",
                      fontSize: "25px",
                    }}
                  >
                    {rtl
                      ? `وتجدر الإشارة إلى أن بوابة أفريقيا `
                      : fr
                      ? `Il convient de noter que la Porte d'entrée à l'Afrique `
                      : `Gateway to Africa,`}{" "}
                  </span>
                  {rtl
                    ? `ليست للأفارقة وحدهم. يركز هذا البرنامج على بناء الدول الأفريقية من خلال توظيف رعاتنا الأوروبيين والشرق أوسطيين وجنوب آسيا الذين يوفرون الموارد اللازمة "لتجهيز المضخة". وسيتعزز دور أفريقيا وهيبتها عندما يقدر العالم أفريقيا تقديرا كاملا وإسهاماتها في نوعية الحياة للجميع`
                    : fr
                    ? `ne s'adresse pas uniquement aux Africains. Ce programme se concentre sur
                    la construction de nations africaines en recrutant nos sponsors européens, moyen-orientaux et sud-asiatiques qui fournissent
                    les ressources pour "amorcer la pompe". Le rôle et le prestige de l'Afrique seront renforcés lorsque le monde en viendra à
                    apprécier pleinement l'Afrique et ses contributions à la qualité de vie de chacun.`
                    : ` it should be noted, is not only for
                                    Africans. This program focuses on building
                                    African nations by recruiting our European,
                                    Middle Eastern and South Asian sponsors who
                                    provide the resources to “prime the pump.”
                                    Africa’s role and prestige will be enhanced
                                    as the world comes to fully appreciate
                                    Africa and its contributions to the quality
                                    of life for everyone.`}
                </p>
                <p>
                  <span
                    class="title c-4"
                    style={{
                      float: "none",
                      fontSize: "25px",
                    }}
                  >
                    {rtl
                      ? `ولئن كان صحيحا أن العديد من الدول`
                      : fr
                      ? `S'il est vrai que de nombreuses nations`
                      : `While it is true that many nations`}
                  </span>{" "}
                  {rtl
                    ? `تأمل في تحقيق ما نقترحه، فإن معظمها لا ينعم بالموارد الطبيعية الوفيرة اللازمة لإنجاح هذه الخطة. وهذه الموارد هي التي ستسمح لبنك مكة المكرمة والمدينة المنورة بجذب المستثمرين من جميع أنحاء العالم لدعم خطتنا التنموية التي تبلغ قيمتها 5 تريليونات دولار أمريكي`
                    : fr
                    ? ` espèrent réaliser ce que nous proposons, la plupart d'entre elles n'ont pas la chance de
                    disposer des abondantes ressources naturelles nécessaires à la réalisation de ce plan. Ce sont ces ressources qui permettront à
                    La Mecque et la Médine Banque d'attirer des investisseurs du monde entier pour soutenir notre plan de développement de 5
                    000 milliards de dollars américains.`
                    : `hope to achieve what we are proposing, most
                                    are not blessed with the abundant natural
                                    resources required to make this plan work.
                                    It is these resources that will allow The
                                    Bank of Makkah & Al Madinah to attract
                                    investors from around the world in support
                                    of our $5 trillion USD development plan.`}
                </p>
                <h3
                  class="title c-4 ff-regular"
                  style={{
                    color: "#d8a419",
                    marginBottom: "20px",
                  }}
                  id="GatewaySaudi"
                >
                  {rtl
                    ? ` بوابة آسيا`
                    : fr
                    ? `LA PORTE D'ENTRÉE VERS L'ASIE`
                    : `GATEWAY TO Asia`}
                </h3>
                <img
                  src={require("../../Assets/images/asia.png")}
                  alt="Asia"
                  style={{
                    display: "none",
                  }}
                  id="AsiaImage"
                />
                <p>
                  <span
                    class="title c-4"
                    style={{
                      float: "none",
                      fontSize: "25px",
                    }}
                  >
                    {rtl
                      ? `العمرة هي رحلة روحية جميلة`
                      : fr
                      ? `L'Omrah est un magnifique`
                      : `Umrah is a beautiful`}{" "}
                  </span>{" "}
                  {rtl
                    ? `يقوم بها كل مسلم للاعتراف بالله (سبحان الله تعالى - المجد له ، تعالى) كنذير سلام والتواصل معه لتطهير الشوائب في الداخل. أي حاج يمضي في هذه الرحلة ، يسير على طريق تطهير روحه وقلبه وجسده من الخطايا التي ارتكبت في الماضي لتمييزه عن الآخرين في يوم القيامة`
                    : fr
                    ? `voyage spirituel que tout musulman entreprend pour
                    reconnaître Allah (Subhanahu Wa Ta'ala - Gloire à lui, l'exalté) comme le messager de la
                    paix et pour communier avec lui afin de purifier les impuretés qui sont en lui. Tout
                    pèlerin qui entreprend ce voyage emprunte le chemin de la purification de son âme, de
                    son cœur, de son esprit et de son corps des péchés commis dans le passé afin de se
                    distinguer des autres le jour de la résurrection.`
                    : `spiritual journey taken by every single
                                    Muslim to acknowledge Allah (Subhanahu Wa
                                    Ta’ala – Glory to him, the exalted) as the
                                    harbinger of peace and to commune with him
                                    to purge the impurities within. Any pilgrim
                                    who proceeds on this journey, goes along the
                                    path to purifying their soul, heart mind and
                                    body from the sins committed in the past to
                                    be distinguished from others on Resurrection
                                    day.`}
                </p>
                <p>
                  <span
                    class="title c-4"
                    style={{
                      float: "none",
                      fontSize: "25px",
                    }}
                  >
                    {rtl
                      ? `في الأساس ،`
                      : fr
                      ? `L'Omrah signifie essentiellement`
                      : `Essentially,`}
                  </span>{" "}
                  {rtl
                    ? `تعني العمرة "زيارة" إلى الكعبة المشرفة (بيت الله الحرام) باللغة العربية ويمكن لأي شخص القيام بها ، في أي وقت من السنة. على عكس الحج ، وهو حج إلزامي إلى مكة المكرمة ، يتم إجراؤه كل عام خلال الأيام ال 10 الأولى من شهر ذي الحجة الإسلامي`
                    : fr
                    ? ` "une visite" à la sainte Kaaba (la maison sacrée de
                        Dieu) en arabe et peut être accomplie par n'importe qui, à n'importe quel moment de
                        l'année, contrairement au Hajj, qui est un pèlerinage obligatoire à la Mecque, accompli
                        chaque année dans les dix premiers jours du mois islamique de Dhul Hijjah.`
                    : `the Umrah means ‘a visit’ to the Holy Kaaba
                                    (the Sacred House of God) in Arabic and can
                                    be performed by anyone, anytime of the year;
                                    unlike Hajj, which is an obligatory
                                    pilgrimage to Makkah, performed every year
                                    within the first 10 days of the Islamic
                                    month of Dhul Hijjah.`}
                </p>
                <p>
                  <img
                    src={require("../../Assets/images/saudi.png")}
                    alt="saudi Flag"
                    id="saudiFlag"
                    style={{
                      display: "none",
                    }}
                  />
                  <span
                    class="title c-4"
                    style={{
                      float: "none",
                      fontSize: "25px",
                    }}
                  >
                    {rtl
                      ? `رحلة الحج`
                      : fr
                      ? `Le voyage du Hajj,`
                      : `The journey of Hajj,`}
                  </span>{" "}
                  {rtl
                    ? `والعمرة والزيارة سهلة وسهلة وسهلة للحفاظ عليها في جو هادئ وسلمي، لتبقى ذكرى لا تنسى ورائعة في ذاكرة الحج والعمرة والزائر لتحقيق الرضا، وجعله سفيرا للعالم بجهود المملكة في خدمة ضيوف الرحمن`
                    : fr
                    ? ` de l'Omrah et de la visite est facile, aisé et facile à maintenir dans une
                    atmosphère calme et paisible, pour rester un souvenir mémorable et merveilleux dans la
                    mémoire du Hajj et de l'Omrah et du visiteur pour obtenir satisfaction, et faire de lui
                    l'ambassadeur dans le monde des efforts du Royaume au service des invités de Rahman.`
                    : `Umrah and the visit is easy, easy and easy
                                    to maintain in a quiet and peaceful
                                    atmosphere, to remain a memorable and
                                    wonderful memory in the memory of Hajj and
                                    Umrah and the visitor to achieve
                                    satisfaction, and make him ambassador to the
                                    world the efforts of the Kingdom in the
                                    service of the guests of Rahman.`}
                </p>
                <p>
                  <span
                    class="title c-4"
                    style={{
                      float: "none",
                      fontSize: "25px",
                    }}
                  >
                    {rtl
                      ? `يقوم بنك الاستثمار الإسلامي`
                      : fr
                      ? `La Mecque et la Médine Banque`
                      : `The Islamic investment Bank`}
                  </span>{" "}
                  {rtl
                    ? ` بواجباته بالتنسيق مع الجهات الحكومية والخاصة لتسهيل أداء الشعائر الدينية`
                    : fr
                    ? `exerce ses fonctions en coordination avec les
                    organismes gouvernementaux et privés pour faciliter l'accomplissement des rituels.`
                    : `performs its duties in coordination with
                                    governmental and private bodies to
                                    facilitate the performance of rituals.`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Gateway;
